export default __webpack_public_path__ + "static/media/Bilo2-7.c72ee8be.jpg";